import { useSelector } from 'react-redux';
import ModalFullView from './ModalFullView';

const AppModals = () => {
  const modal = useSelector((state) => state.modal);

  const renderModal = () => {
    switch (modal.activeName) {
      case 'full-view':
        return <ModalFullView />;
      default:
        return null;
    }
  };

  return <>{renderModal()}</>;
};

export default AppModals;
